<mat-toolbar>Add Incident Type</mat-toolbar>
<div class="Dialog-body">
  <form>
    
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text" matInput placeholder="Name" [(ngModel)]="selectedName" [ngModelOptions]="{standalone: true}">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text" matInput placeholder="Description" [(ngModel)]="selectedDescription" [ngModelOptions]="{standalone: true}">
    </mat-form-field>

      <div class="buttonbelow">
        <button mat-raised-button (click)="DialogClose()">Cancel</button>    
        <button mat-raised-button (click)="addIncident()">Submit</button>
       
      </div>
  </form>

</div>